export default __webpack_public_path__ + "static/media/indianSubcontinent.27edc1e7.svg";